<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <div class="d-flex min-height-100" @mouseover="hover = true" @mouseleave="hover = false">
            <div class="formium-item-handle left-side d-flex flex-column justify-content-between align-items-start">
                <div class="font-weight-bold d-flex justify-content-center w-100" style="font-size: 1.3rem;">
                    <span class="hide-during-drag" :class="isValid ? 'text-muted' : 'text-danger'">{{ currentPosition }}</span>
                    <!-- <b-icon v-if="!isValid" icon="exclamation-circle" variant="danger" class="icon-invalid" aria-hidden="true"></b-icon> -->
                    <!--<span style="font-size: 0.5rem;">{{localValue.id}}</span>-->
                </div>
                <div class="small">
                    <!--{{ localValue.type }}-->
                </div>
                <div class="flex-grow-1 w-100 d-flex justify-content-center align-items-center">
                    <b-icon :icon="itemtypeIcon" :variant="isSelected ? 'primary' : 'secondary'" scale="1.5" aria-hidden="true"></b-icon>
                </div>
            </div>
            
            <div class="right-side w-100 position-relative">

                <div class="formium-item-handle position-absolute w-100 h-100" style="top: 0; left: 0;">
                    <!-- Just for making drag handle work on firefox over the form -->
                </div>

                <b-form-group
                    :description="localValue.help_text"
                    disabled
                >
                    <template v-if="!hideLabelTypes.includes(localValue.type)" v-slot:label>
                        <span :class="labelValid ? '' : 'text-danger-300'">{{ localValue.label || '[Question Text]' }}</span>
                        <span v-if="localValue.required" class="text-danger ml-1">*</span>
                    </template>
                    <b-form-textarea required v-if="localValue.type === 'text-area'" placeholder="Some longer answer will go here." rows="2"></b-form-textarea>
                    <b-form-input v-else-if="localValue.type === 'email'" placeholder="person@company.com" type="email"></b-form-input>
                    <b-form-input v-else-if="localValue.type === 'decimal'" placeholder="63" type="number"></b-form-input>
                    <b-form-datepicker v-else-if="localValue.type === 'date'" value="2020-03-10" placeholder="Please select a date"></b-form-datepicker>
                    <b-form-input v-else-if="localValue.type === 'time'" value="12:30" type="time" class="w-50"></b-form-input>
                    <b-input-group v-else-if="localValue.type === 'django-money-field'" :prepend="localValue.currency ? localValue.currency : '$€¥'" append=".00" class="w-50">
                        <b-form-input placeholder="100" style="text-align: right;"></b-form-input>
                    </b-input-group>
                    <b-form-radio-group v-else-if="localValue.type === 'select-yes-no'" :options="['Yes', 'No']"></b-form-radio-group>
                    <b-form-radio-group v-else-if="localValue.type === 'single-select'" :options="choicesArray"></b-form-radio-group>
                    <b-form-checkbox-group v-else-if="localValue.type === 'multiple-select'" :options="choicesArray"></b-form-checkbox-group>
                    <b-form-checkbox v-else-if="localValue.type === 'checkbox-confirm'">{{ localValue.label || '[Question Text]' }} <span v-if="localValue.required" class="text-danger ml-1">*</span></b-form-checkbox>
                    <b-form-file v-else-if="localValue.type === 'file-upload-direct'" placeholder="Choose a file or drop it here..."></b-form-file>
                    <b-form-radio-group v-else-if="localValue.type === 'simple-rating'" :options="choicesArray"></b-form-radio-group>
                    <b-form-input v-else placeholder="The answer will go here"></b-form-input>
                </b-form-group>

            </div>
        </div>
    </div>
</template>

<script>
import { emptyItem } from '../../js/formium-helpers';  // itemTypes

// NEW VERSION -- this is just a 'stupid' DISPLAY thing... not for doing any updates, validations, etc.

export default {
    name: 'FormiumFormBuilderItem',
    components: {},
    props: {
        value: Object,
        listIndex: Number,
        isSelected: Boolean,
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            hover: false,
            hideLabelTypes: [
                'checkbox-confirm',
                // any others where we don't show the label in normal slot and instead show it in the label of the input itself?
            ],
        }
    },
    computed: {
        currentPosition: function() {
            return this.listIndex + 1;
        },
        localValue: function() {
            // IMPORTANT:  we do this to make sure we handle the null state (no value passed yet)
            // and also makes sure we're not mutating v-model value directly -- all mutating should be done to this
            // DO YOU NEED THIS ANYMORE?  WILL YOU EVER HAVE THIS COMPONENT WITHOUT VALUE?  Probably not needed...
            return this.value ? this.value : emptyItem;
        },
        hasChoices: function() {
            return this.value.itemType.hasChoices;
        },
        choicesValid: function() {
            return this.value.choicesValid();  // call object method on FormItem passed in
        },
        choicesArray: function() {
            if (!this.hasChoices) return [];
            //let cleanChoices = this.localValue.choices.split(",").map((choice)=>choice.trim()).filter(ch => !!ch);
            let cleanChoices = this.value.getChoicesArray();
            return cleanChoices.length ? cleanChoices : ['[choice]'];  // return a single blank choice just for display, to show first checkbox if totally empty
        },
        labelValid: function() {
            return this.value.labelValid();
        },
        itemtypeIcon: function() {
            return this.value.itemType.iconName;
        },
        showDetails: function() {
            return this.hover || this.isSelected;
        },
        isValid: function() {
            return this.value.isValid;
        },
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
    }
}
</script>

<style>
.formium-item-handle {
    cursor: move;
}

</style>
